import React from 'react';
import { StyledFormControl } from '../../../components/modal-form/styles';

interface Props {
  entidade: any;
  handleInputChange: (campo: string, valor: string | number | boolean) => void;
  disabled?: boolean;
}

// Início e fim da madrugada (HH:mm). O fuso é o do endereço de cada locatário, aplicado no servidor.
const HorarioPernoiteInput: React.FC<Props> = ({ entidade, handleInputChange, disabled }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
    <span style={{ fontSize: 13, color: '#555' }}>das</span>
    <StyledFormControl
      type="time"
      value={entidade?.horaInicio || '00:00'}
      disabled={disabled}
      onChange={(e: any) => handleInputChange('horaInicio', e.target.value)}
      style={{ maxWidth: 130 }}
    />
    <span style={{ fontSize: 13, color: '#555' }}>às</span>
    <StyledFormControl
      type="time"
      value={entidade?.horaFim || '05:00'}
      disabled={disabled}
      onChange={(e: any) => handleInputChange('horaFim', e.target.value)}
      style={{ maxWidth: 130 }}
    />
  </div>
);

export default HorarioPernoiteInput;
